// Enterprise Invitation Result Model
export class EnterpriseInvitation {
  constructor(data = {}) {
    this.message = data.message || '';
    this.credentials = data.credentials || null; // { email } or similar
  }
}

export default EnterpriseInvitation;
